import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class InputformatService {

  constructor() { }

  //This Method is Mainly used for Input from Mobile Devices.

  isNumericOrHyphenOrSpace(event: any, regexPattern: string) {
    const inputValue = event.target.value;
    if (!regexPattern) {
      return;
    }
    const regex = new RegExp(regexPattern);
    if (!regex.test(inputValue)) {
      switch (regexPattern) {
        case "/^[0-9.]*$/":
          return event.target.value = inputValue.replace(/[^0-9.]/g, '');
        case "/^[0-9]*$/":
          return event.target.value = inputValue.replace(/[^0-9]/g, '');
        case "/^[0-9- ]*$/":
          return event.target.value = inputValue.replace(/[^0-9- ]/g, '');
        case "/^[0-9,]*$/":
          return event.target.value = inputValue.replace(/[^0-9,]/g, '');
        case "/^[0-9A-Za-z]*$/":
          return event.target.value = inputValue.replace(/[^0-9A-Za-z]/g, '');
        case "/^[a-zA-Z ]*$/":
          return event.target.value = inputValue.replace(/[^a-zA-Z \u0B80-\u0BFF]/g, '');
        case "/^[a-zA-Z0-9 ]*$/":
          return event.target.value = inputValue.replace(/[^a-zA-Z0-9 \u0B80-\u0BFF]/g, '');
        case "/^[a-zA-Z0-9a ]*$/":
          return event.target.value = inputValue.replace(/[^a-zA-Z0-9 ]/g, '');
        case "/^[A-Z0-9]*$/":
          return event.target.value = inputValue.replace(/[^A-Z0-9]/g, '');
        case "/^[.,/()a-zA-Z -]*$/":
          return event.target.value = inputValue.replace(/[^.,/()a-zA-Z -]/g, '');
          case "/^[.,/()a-z0-9A-Z -]*$/":
          return event.target.value = inputValue.replace(/[^:.,/()a-z0-9A-Z -]/g, '');
        case "/^[.a-zA-Z0-9 -]*$/":
          return event.target.value = inputValue.replace(/[^.a-zA-Z0-9 -]/g, '');
        case "/^[^a-zA-Z\u0B80-\u0BFF ]*$/":
          return event.target.value = inputValue.replace(/[^a-zA-Z\u0B80-\u0BFF ]/g, '');
        case "/^[.,/()a-z0-9A-Z\u0B80-\u0BFF ]*$/":
          return event.target.value = inputValue.replace(/[^ :..,/()a-z0-9A-Z\u0B80-\u0BFF ]/g, '');
        case "/^[\u0B80-\u0BFF ]*$/":
          return event.target.value = inputValue.replace(/[\u0B80-\u0BFF ]/g, '');
        default:
          return event.target.value;
      }
    }
  }

}
